import React, {
    FC
} from "react";

import
{
    IonItem,
    IonLabel
} from '@ionic/react';

import SettingsNumberInput from '../../../../../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput';
import { MAX_DEVICE_NUMBER } from "../../../../../../../../utils";
import { Locale } from "../../../../../../../../setup/locale";
import { useL10n } from "@ews/react-localization-context";
import style from "./NuberRange.module.scss";
import { useIsMobile } from "../../../../../../../Responsive";

type OnChangeHandler = (from: number, to: number) => void;

const NumberRange: FC<{ disabled?: boolean, label: Locale, from?: number, to?: number; onChange?: OnChangeHandler; }> = ({
    disabled,
    label,
    from = 0,
    to = MAX_DEVICE_NUMBER,
    onChange
}) =>
{

    const { translate: t } = useL10n();
    const mobileView = useIsMobile();

    return <IonItem className={mobileView ? style.mobile : ""}>

        <div style={{ width: "100%" }}>
            <IonLabel class="">{t(label)}</IonLabel>
        </div>

        <SettingsNumberInput
            disabled={disabled}
            lines="none"
            text={"COM_FACPMANAGEMENT_LOGS_EVENTS_EXPORT_PDF_FOOTER_OF"}
            endText=".:"
            value={from}
            onChange={(value) => onChange && onChange(value, to)}
        />

        <SettingsNumberInput
            disabled={disabled}
            lines="none"
            text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_TO"}
            endText=".:"
            value={to}
            onChange={(value) => onChange && onChange(from, value)}
        />
    </IonItem>;
};

export default NumberRange;
